import { AfterViewInit, Component, Directive, HostListener } from "@angular/core";

import { BaseComponent } from "../../base/base.component";

@Directive()
export class MobileComponent extends BaseComponent implements AfterViewInit {
  isMobile = false;
  isTablet = false;
  isDesktop = false;
  isLargeScreen = false;
  constructor() {
    super();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isMobileWidth(window.innerWidth);
      this.isDesktopWidth(window.innerWidth);
      this.isTabletWidth(window.innerWidth);
      this.isLargeWidth(window.innerWidth);
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.isMobileWidth(event.target.innerWidth);
    this.isDesktopWidth(event.target.innerWidth);
    this.isTabletWidth(event.target.innerWidth);
    this.isLargeWidth(event.target.innerWidth);
  }

  private isMobileWidth(width) {
    this.isMobile = width <= 600;
  }

  private isDesktopWidth(width) {
    this.isDesktop = width >= 960;
  }

  private isTabletWidth(width) {
    this.isTablet = width > 600 && width < 960;
  }

  private isLargeWidth(width) {
    this.isLargeScreen = width >= 1280;
  }

  isMobileScreen(): boolean {
    return window.innerWidth <= 600;
  }
}
